export function generateID(): string {
    return Math.random().toString(36).slice(-8);
}

// const wattFormatter = new Intl.NumberFormat('en-US', {
//     style: 'unit',
//     unit: 'watt',
//     unitDisplay: 'short',
//     notation: "compact",
//     compactDisplay: "short",
//     maximumFractionDigits: 1
// });
export function formatWatts(watts: number): string {
    if (watts === null || watts === undefined) return '0 W';

    if (watts >= 1000000) {
        return (watts / 1000000).toFixed(2) + ' MW';
    } else if (watts >= 1000) {
        return (watts / 1000).toFixed(2) + ' kW';
    } else {
        return Math.floor(watts) + ' W';
    }
}

const byteFormatter = Intl.NumberFormat("en", {
    notation: "compact",
    style: "unit",
    unit: "byte",
    unitDisplay: "narrow",
});
export function formatBytes(a: number): string {
    return byteFormatter.format(a);
}

export function round(num: number, precision: number = 0) {
    if (Math.abs(num) < Math.pow(10, -precision - 1)) return 0;
    if (!Number.isFinite(num)) return num;
    return +(Math.round(Number(num + "e" + precision)) + "e-" + precision);
}


export function clamp(num: number, min: number, max: number) {
    return Math.min(Math.max(num, min), max);
}

// Equivalent to num == clamp(num, min, max)
export function within(num: number, min: number, max: number) {
    return min <= num && num <= max;
}

export function toFixed(number: any, decimals: number): string {
    if (number === undefined || number === null) return '???'
    if (!Number.isFinite(number)) return String(number).substring(0, 5);
    return number.toFixed(decimals);
}

export function capStringLen(str: string, len: number) {
    if (str.length > len) return str.slice(0, len) + '...';
    return str;
}

export async function sleep(ms: number) {
    // @ts-ignore
    return new Promise(resolve => setTimeout(resolve, ms));
}

export async function awaitAnimationFrame(): Promise<void> {
    // @ts-ignore
    return new Promise(requestAnimationFrame);
}

export function inchesToMeters(inches: number) {
    return inches * 0.0254;
}

export function m2ToAcres(m2: number) {
    return m2 * 0.000247105381;
}

export function both(a: Function, b: Function) {
    return (x: any) => {
        a ? a(x) : undefined;
        b ? b(x) : undefined;
    }
}

export function s(iter: any[] | number | undefined): 's' | '' {
    if (!iter) return 's'; // Zero missions, undefined missions, we will see.
    return (typeof iter == 'number' ? iter : iter.length) === 1 ? '' : 's';
}

export function toLocalISODateString(date: Date): string {
    if (!date) return '';
    return date.getFullYear() + '-' +
        String(date.getMonth() + 1).padStart(2, '0') + '-' +
        String(date.getDate()).padStart(2, '0');
}

export function toLocalISOTimeString(date: Date, ms: boolean = false): string {
    if (!date) return '';
    return String(date.getHours()).padStart(2, '0') + ':' +
        String(date.getMinutes()).padStart(2, '0') + ':' +
        String(date.getSeconds()).padStart(2, '0') +
        (ms ? '.' + String(date.getMilliseconds()).padStart(3, '0') : '');
}

export function toLocalISOString(date: Date): string {
    if (!date) return '';
    return toLocalISODateString(date) + 'T' + toLocalISOTimeString(date, true);
}

export function sum(...args: number[]): number {
    return args.reduce((a, b) => a + b, 0);
}

export function sortBy(key: string | number, reverse: boolean = false) {
    return (a: any, b: any) => {
        if (a[key] < b[key]) return reverse ? 1 : -1;
        if (a[key] > b[key]) return reverse ? -1 : 1;
        return 0;
    }
}

export function rank<T>(arr: T[], func: (a: T) => number, ascending: boolean = false): T[] {
    // precompute the scores, so they are only calculated once
    const rf = ascending ? 1 : -1;
    const withScores = arr.map(e => ({ e, score: func(e) }));
    withScores.sort((a, b) => (a.score - b.score) * rf);
    return withScores.map(e => e.e);
}

export function sortKeys<T extends Record<string, unknown>>(obj: T): T {
    return Object.keys(obj)
        .sort()
        .reduce((acc, k) => {
            // @ts-ignore
            acc[k as keyof T] = obj[k];
            return acc;
        }, {} as T);
}

export const unpackerOptions = {int64AsType: 'number', mapsAsObjects: true} as const;

export const defaultBlue = "#6495ED";
export const colors = ['red', 'blue', 'green', 'yellow', 'orange', 'purple', 'pink', 'black'];